/**
 * 手駒コンポーネント
 *
 * プレイヤーの手駒を表示
 */

import React from 'react';
import { Piece } from './Piece';
import type { Piece as PieceType, PieceType as PT } from '@/types/game';
import { useUIStore } from '@stores/uiStore';

interface HandProps {
  pieces: PieceType[];
  playerPosition: number;
  isHuman: boolean;
}

export const Hand: React.FC<HandProps> = ({ pieces, playerPosition, isHuman }) => {
  const { selectedPiece, setSelectedPiece } = useUIStore();

  const handlePieceClick = (pieceType: PT) => {
    if (isHuman) {
      const newSelection = pieceType === selectedPiece ? null : pieceType;
      setSelectedPiece(newSelection);
    }
  };

  // 駒の向き（縦長 or 横長）
  // P0, P2（下・上）: 縦長
  // P1, P3（右・左）: 横長
  const isVertical = playerPosition === 0 || playerPosition === 2;
  const pieceOrientation = isVertical ? 'vertical' : 'horizontal';

  return (
    <div className="p-6 rounded-lg">
      <h3 className="text-sm font-bold mb-2">
        {isHuman ? 'あなたの手駒' : `プレイヤー${playerPosition + 1}の手駒`}
      </h3>
      <div className="flex gap-3 flex-wrap justify-start w-full">
        {pieces.map((piece, index) => {
          const isSelected = isHuman && selectedPiece === piece.type;
          return (
            <Piece
              key={`p${playerPosition}-${index}`}
              piece={piece}
              selected={isSelected}
              disabled={!isHuman}
              onClick={() => piece.visible && handlePieceClick(piece.type)}
              orientation={pieceOrientation}
              size={isHuman ? 'large' : 'normal'}
            />
          );
        })}
      </div>
    </div>
  );
};
